import axios from 'axios';
import authHeader from './auth-header';
import publicHeader from './public-header';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}`;

class DefaultSettingService {
  getDefaultSetting() {
    return axios.get(`${API_URL}/Admin/Setting/Default`,
      {
        headers: publicHeader()
      })
      .then(response => {
        return response.data;
      });
  }

  updateDefaultSetting(setting) {
    return axios.post(`${API_URL}/Admin/Update/DefaultSettings`,
    setting,
      {
        headers: authHeader()
      })
      .then(resp => {
        return resp.data;
      });
  }
}

export default new DefaultSettingService();